import { Injectable } from "@angular/core";
import { AdAnimationStore } from "./ad-animations.store";
import { arrayUpsert } from "@datorama/akita";

@Injectable({ providedIn: 'root' })
export class AdAnimationService {

	constructor(
		private readonly animationStore: AdAnimationStore,
	) {}

	/**
	 * Updates the isMuted property.
	 */
	updateIsMuted(isMuted: boolean) {
		this.animationStore.update({
			isMuted: isMuted
		});
	}

	updateSeek(seek: number) {
		this.animationStore.update({
			seek: seek
		});
	}

	updateTimelineZoomLevel(timelineZoomLevel: number) {
		if (timelineZoomLevel < 1) {
			timelineZoomLevel = 1;
		}

		if (timelineZoomLevel > 10) {
			timelineZoomLevel = 10;
		}
		this.animationStore.update({
			timelineZoomLevel: timelineZoomLevel
		});
	}

	updateTimelinePrecisionLevel(updateTimelinePrecisionLevel: number) {
		if (updateTimelinePrecisionLevel < 1) {
			updateTimelinePrecisionLevel = 1;
		}

		if (updateTimelinePrecisionLevel > 10) {
			updateTimelinePrecisionLevel = 10;
		}
		this.animationStore.update({
			timelinePrecisionLevel: updateTimelinePrecisionLevel
		});
	}

	/**
	 * Updates the active audio creative unit id.
	 * @param id The id of the creative unit to set as active.
	 */
	updateActiveAudioCreativeUnitId(id: string) {
		this.animationStore.update({
			activeAudioCreativeUnitId: id
		});
	}

	/**
	 * Upserts a timeline to the timelines array.
	 */
	upsertTimeline(id: string, timeline: GSAPTimeline) {
		this.animationStore.update({
			timelines: arrayUpsert(this.animationStore.getValue().timelines, timeline?.data?.id, timeline, 'data.id')
		});
	}

	/**
	 * Removes a timeline from the timelines array.
	 */
	removeTimeline(id: string) {
		this.animationStore.update(state => {
			let index = state.timelines.findIndex(t => t.data.id === id);
			if (index > -1) {
				state.timelines.splice(index, 1);
			}
			return state;
		});
	}

	/**
	 * Clears all timelines.
	 */
	clearTimelines() {
		this.animationStore.update({
			timelines: []
		});
	}

	/**
	 * Flips the state of the animation property.
	 * Note: Callers should verify timeline visibility using shouldShowTimelineUtil() 
	 * before calling this method to ensure proper configuration validation.
	*/
	toggleAnimation(state?: boolean) {
		console.log('toggle animations');

		// Safety check: ensure we have registered timelines before toggling
		// This prevents errors when trying to play/pause non-existent animations

		if (state === undefined) {
			state = !this.animationStore.getValue().isPlaying;
		}

		this.animationStore.update({
			isPlaying: state
		});
	}

	/**
	 * Reset the animation store to its initial state, excluding the mute state.
	 */
	 reset() {
		this.animationStore.update({
			isPlaying: false,
			// isMuted: true,
			// activeAudioCreativeUnitId: undefined,
			seek: 0,
			timelineZoomLevel: 4,
			timelinePrecisionLevel: 4,
			timelines: []
		})
	}

}
